import { shortDate } from './format';

export function appHref(url: string | null): string | null {
  const trimmed = url?.trim() ?? '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : null;
}

export function expiryLabel(expiresAt: string | null): string | null {
  return expiresAt ? `Expires ${shortDate(expiresAt)}` : null;
}
